import React, { Component } from 'react';

import './NavButton.scss'

import icon_menu from '../../assets/menu_blk.svg';

class NavButton extends Component {
    static defaultProps = {
        primary: true,
        secondary: false,
        disabled: false,
        className: '',
        onClick: () => { },
    }

    handleClick = e => {
        e.preventDefault()
        if (!this.props.disabled && this.props.onClick) {
            this.props.onClick()
        }
    }

    render() {
        const { label, disabled, secondary, primary, small, className, icon } = this.props

        const buttonType = small
            ? 'small'
            : secondary
                ? 'secondary'
                : primary
                    ? 'primary'
                    : ''

        const disabledClass = disabled ? 'disabled' : ''

        const iconClass = icon ? 'icon' : ''

        return (
            <div>
                <button
                    className={`nav-button ${buttonType} ${disabledClass} ${iconClass} ${className}`}
                    onClick={this.handleClick}
                    disabled={disabled}
                >
                    { icon=='menu' && (
                        <img src={icon_menu} />
                    )}

                    {label}
                </button>
            </div>
        )
    }
}

export default NavButton;